import React, { Component, createRef } from 'react';
import { Input, List, Label, Grid, Button, Icon, Checkbox } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import fuzzysort from 'fuzzysort';
import axios from 'axios';
import { API_URL } from '../App.js';
// import { YugtunLoader, WordItem, TagColors } from './HomeHelper.js';
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
// import { sanitize } from 'dompurify';
// import {categories} from './constants/categories.js';
// import {categoriesUrlLookup} from './constants/categoriesUrlLookup.js';
import Citation from './Citation.js'

// import { dialogueGenerator } from './constants/dialogueListGenerator.js';
//test

import * as Scroll from 'react-scroll';
// import { Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import ReactGA from "react-ga4";
ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;

const options1 = {
  keys: ['eTerm','yTerm','eDesc','yDesc'],
  limit: 40, // don't return more results than you need!
  threshold: -0, // don't return bad results
};



let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
}


class NewHome extends Component {
	constructor(props) {
		super(props);
    // console.log(props,props.location.state.currentCategory !== 'all')
		this.state = {
			search: props.location.state === undefined || 'currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? '' :props.location.state.history[0],
			wordsList: props.location.state === undefined || 'currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? [] : props.location.state.history[1],
      activeTabIndex: props.location.state === undefined ? 0 : ('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? 3 : props.location.state.history[3]),
      homeMode: props.location.state === undefined ? 0 : ('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? 3 : props.location.state.history[3]),
      tabValue: props.location.state === undefined ? 0 : ('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? 3 : props.location.state.history[3]),
      activeAudioIndex: props.location.state === undefined || 'currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? {} : props.location.state.history[4],

      parseIndex:0,
      playingAudio: false,
      prevSearch: [],
      prevWordsList: [],
      logoup:false,

      currentCategory: props.location.state === undefined ? 'all' :('currentCategory' in props.location.state && props.location.state.currentCategory !== 'all' ? props.location.state.currentCategory:'all'),
      childrenCategories:[],
      parentCategories:[],

      categoriesDisplayed:[],
      // combinedAudio:[],

      useExample:true,
      useConversational:true,
      usePhrasebook:true,
      audioFilterChangeable:true,

      seeMoreAcknowledgments:false,
		}
    // console.log('new')
		this.handleRef = createRef()
		// this.handleRef2 = createRef()

    if (props.location.state !== undefined && 'history' in props.location.state) {
      // console.log('hi',props.location.state.history[2])
      scroll.scrollTo(props.location.state.history[2]);
    }
	}

  // componentDidMount() {
  //   const categoriesDisplayed = [];
  //   for (var key of Object.keys(categories)) {
  //     if (!key.includes(".")) {
  //       categoriesDisplayed.push(key)
  //     }   
  //   }
  //   const queryParameters = new URLSearchParams(window.location.search)
  //   const category = queryParameters.get("category")
  //   if (category !== null) {
  //     this.setState({activeTabIndex:3, homeMode:3, tabValue:3})
  //     if (category in categoriesUrlLookup) {
  //       this.setState({currentCategory:categoriesUrlLookup[category] })
  //       this.retrieveFamilyCategories(categoriesUrlLookup[category])
  //     } else {
  //       this.props.history.push('/?category=all')
  //     }      
  //   }
  //   this.setState({ categoriesDisplayed: categoriesDisplayed });

  //   // console.log(this.props.audioSearchList)
  //   // console.log(this.props.audiolibrary)
  //   // this.setState({combinedAudio:[...this.props.audioSearchList,...this.props.audiolibrary]})
  //   // this.setState({combinedAudio:this.props.audiolibrary})
  // }
  
  // componentDidUpdate(prevProps, prevState) {
  //   if (this.state.currentCategory !== 'all' && this.state.parentCategories.length == 0 && this.state.childrenCategories.length == 0) {
  //     this.retrieveFamilyCategories(this.state.currentCategory)
  //     scroll.scrollTo(0);
  //   }
  //   if (this.state.currentCategory !== 'all' && this.state.wordsList.length == 0 && categories[this.state.currentCategory].links.length>0) {
  //     this.retrieveFamilyCategories(this.state.currentCategory)
  //     scroll.scrollTo(0);
  //   }

  //   if (this.state.useExample !== prevState.useExample || this.state.useConversational !== prevState.useConversational || this.state.usePhrasebook !== prevState.usePhrasebook) {
  //     this.onChangeSearch(true, 2, null,this.state.search)
  //   }
  // }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll)
  }

  listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop

    this.setState({
      Yposition: winScroll,
    })
  }

  // setHistory = (num) => {
  //   this.setState({
  //     prevSearch:num[0],
  //     prevWordsList:num[1],
  //   })
  // }

  // resetAll = (e,data) => {
  // 	this.setState({
  // 		search:"",
  //     // newSearchList:[],
  //     searchWord:"",
  // 	})
  // }



		// returnTitle = (word) => {
		// 	let newword = word.split(' | ');
		// 	let fulllist = [];
		// 	for (let i = 0; i < newword.length; i++) {
		// 		if (newword[i].includes('(‐)')) {
		// 			fulllist.push(newword[i].split('(‐)')[0])
		// 			fulllist.push(newword[i].split('(‐)')[0]+'‐')
		// 		} else {
		// 			fulllist.push(newword[i])
		// 		}
		// 	}
		// 	return fulllist
		// }

		// returnDefinition = (word) => {
		// 	let newword = word.split(' | ')
		// 	return newword
		// }
    // tlingitNormalize = (tlingit) => {
    //   tlingit = tlingit.replaceAll('Á','Á').replaceAll('Á','Á')
    //   tlingit = tlingit.replaceAll('É','É').replaceAll('É','É')
    //   tlingit = tlingit.replaceAll('Í','Í').replaceAll('Í','Í')
    //   tlingit = tlingit.replaceAll('Ó','Ó').replaceAll('Ó','Ó')
    //   tlingit = tlingit.replaceAll('Ú','Ú').replaceAll('Ú','Ú')
    //   tlingit = tlingit.replaceAll('á','á').replaceAll('á','á')
    //   tlingit = tlingit.replaceAll('é','é').replaceAll('é','é')
    //   tlingit = tlingit.replaceAll('í','í').replaceAll('í','í')
    //   tlingit = tlingit.replaceAll('ó','ó').replaceAll('ó','ó')
    //   tlingit = tlingit.replaceAll('ú','ú').replaceAll('ú','ú')
    //   tlingit = tlingit.replaceAll('ʼ',"'")
    //   tlingit = tlingit.replaceAll('̱','̲')
    //   tlingit = tlingit.replaceAll('Ḵ','K̲')
    //   tlingit = tlingit.replaceAll('ḵ','k̲')
    //   return tlingit
    // }

    // returnCorrectAudioLibrary = () => {
    //     if (this.state.useExample && this.state.useConversational && this.state.usePhrasebook) {
    //       return this.props.audiolibrary
    //     } else if (this.state.useExample && this.state.useConversational ) {
    //       return this.props.oneandtwo
    //     } else if (this.state.useConversational && this.state.usePhrasebook ) {
    //       return this.props.twoandthree
    //     } else if (this.state.useExample && this.state.usePhrasebook ) {
    //       return this.props.oneandthree
    //     } else if (this.state.useExample) {
    //       return this.props.examplesentenceaudio1
    //     } else if (this.state.useConversational) {
    //       return this.props.conversational2
    //     } else if (this.state.usePhrasebook) {
    //       return this.props.phrasebookaudio3
    //     } else { // edge case
    //       return this.props.audiolibrary
    //     }
    // }

  	onChangeSearch = (bool,homeMode,event,data) => {
      // console.log(bool,homeMode, event,data)
      let word
      if (bool) {
        word = data
      } else {
        word = data.value
        homeMode = this.state.homeMode
      }

	    let new_search
      let wordsList
      // word = this.tlingitNormalize(word)
      new_search = word.replaceAll('ġ','g').replaceAll('s/he','').replaceAll('O-S-ø-','').replaceAll('S-ø-','').replaceAll(' (Ø act)','').replaceAll(' (Ø state)','')

      // console.log(word, new_search, homeMode)
	    if (homeMode === 0) {
        wordsList = fuzzysort.go(new_search, this.props.masterMedicalList, options1)
      } 
      // else if (homeMode === 1) {
      //   // wordsList = fuzzysort.go(new_search, this.props.dictionarySearchList, options2)
	    // } else if (homeMode === 2) {
      //   // console.log(wordsList)
      //   wordsList = fuzzysort.go(new_search, this.returnCorrectAudioLibrary(), options3)
	    // }


	    this.setState({ wordsList: wordsList, search: word,  activeAudioIndex: {} },()=>{this.setState({audioFilterChangeable:true})});
  	}

  	// processStyledText = (sentence) => {
    //   sentence = sentence.replaceAll("???","...")
    //   sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("«",'"').replaceAll("»",'"')

    //   return <span>{sentence}</span>

    //   // let matches = sentence.match(/⎡.*?⎤/g)
    //   // let matches1 = sentence.match(/{.*?}/g)
    //   // let matches2 = sentence.match(/_.*?_/g)
    //   // // console.log(matches2)
    //   // if (matches !== null || matches1 !== null || matches2 !== null) {
    //   //   if (matches !== null) {
    //   //     matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
    //   //   }
    //   //   if (matches1 !== null) {
    //   //     matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
    //   //   }
    //   //   if (matches2 !== null) {
    //   //     matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
    //   //   }
    //   //   return <span dangerouslySetInnerHTML={{__html: sentence}} />    
    //   // } else {
    //   //   return <span>{sentence}</span>
    //   // }


  	// }


    // processStyledTextLink = (sentence) => {
    //   sentence = sentence.replaceAll(">","")


    //   sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("↞","").replaceAll("&","").replaceAll("↠","")
    //   let matches = sentence.match(/⎡.*?⎤/g)
    //   let matches1 = sentence.match(/{.*?}/g)
    //   let matches2 = sentence.match(/_.*?_/g)
    //   // console.log(matches2)
    //   if (matches !== null || matches1 !== null || matches2 !== null) {
    //     if (matches !== null) {
    //       matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
    //     }
    //     if (matches1 !== null) {
    //       matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
    //     }
    //     if (matches2 !== null) {
    //       matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
    //     }
    //     return <span style={{whiteSpace:'nowrap'}} dangerouslySetInnerHTML={{__html: sentence}} />    
    //   } else {
    //     return <span style={{whiteSpace:'nowrap'}}>{sentence}</span>
    //   }


    // }

  	// processUsageDefinition = (definition, tag, ind) => {
  	// 	// console.log(definition)
		// 	let matches = definition.match(/<.*?>/g)

		// 	if (matches !== null) {
		// 		matches.map((m) => definition = definition.replaceAll(m,"<i>"+m.slice(1,-1)+'</i>'))				
		// 	}
		// 	let matches1 = definition.match(/⎡.*?⎤/g)
		// 	if (matches1 !== null) {
		// 		matches1.map((m) => definition = definition.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))				
		// 	}

    //   let matches2 = definition.match(/_.*?_/g)
    //   if (matches2 !== null) {
    //     matches2.map((m) => definition = definition.replaceAll(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
    //   }

    //   let matches3 = definition.match(/{.*?}/g)
    //   if (matches3 !== null) {
    //     matches3.map((m) => definition = definition.replaceAll(m,m.slice(1,-1)))            
    //   }

		// 	if (tag !== 'noun') {
		// 		definition = '<i>s/he/it is </i>'+definition
		// 	}

		// 	definition = definition.replaceAll("⟨","").replaceAll("⟩","")

  	// 	return <span dangerouslySetInnerHTML={{__html: definition}} />
  	// }		


  	// processAudioDefinition = (sentence) => {			
    //   // console.log(sentence)
		// 	let matches = sentence.match(/⎡.*?⎤/g)
		// 	if (matches !== null) {
		// 		matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))				
		// 	}
		// 	sentence = sentence.replaceAll('>','')
		// 	// console.log(sentence)
		// 	// var dom = document.createElement('span');
		// 	// dom.innerHTML = sentence;
  	// 	return <span dangerouslySetInnerHTML={{__html: sentence}} />
  	// }


  repeatAudio(audio, event, data) {

    if (!this.state.playingAudio) {

      let sound = new Audio(API_URL + "/aijaudiolibrary/" + audio);
      this.setState({playingAudio: true});

      sound.play()

      sound.onended=()=>{
        this.setState({playingAudio: false});
      }
    }
  }

  // soundDone = () => {
  //   console.log('done!')
  // }

  setActiveAudioIndex = (word, index) => {
    // console.log(word, index)
    let activeAudioIndex = this.state.activeAudioIndex
    if (index in activeAudioIndex) {
      delete activeAudioIndex[index]
      this.setState({activeAudioIndex:activeAudioIndex})
    } else {
      activeAudioIndex[index] = ""
      this.setState({activeAudioIndex:activeAudioIndex})
    }
  }


	render() {
    // console.log(this.state)
    // console.log(this.props)
		let isCommon = false
    let displayList = (this.state.search.length >= 2 && this.state.wordsList.length > 0) || (this.state.homeMode === 3 && this.state.wordsList.length > 0);
    let wordsList = this.state.wordsList;
    let emptyList = this.state.search.length >= 2 && this.state.wordsList.length === 0 && this.state.activeTabIndex !== 3;
    let categoryMargin = '4px'
    let previewCharLimit = 100
    let dopreview = false

    let paddingtext = 15
		return (
			<div className="app" style={{fontFamily:customFontFam}}>
      <Grid textAlign='center'>
      <Grid.Row>
      <Grid.Column style={{ maxWidth: 800 }} textAlign='left'>
            <div style={{padding:'25px 0px'}}>
              <div onClick={this.resetAll} style={{fontFamily:customFontFam, color: 'black', fontSize:'17pt', fontWeight:'600', paddingBottom:'8px'}}>Aperyarat Calricaraam Tungiinun</div>
              <div onClick={this.resetAll} style={{fontFamily:customFontFam, color: 'black',fontSize:'17pt',lineHeight:'25px',cursor:'pointer', fontWeight:'300'}}>Terminology Related to Health & Well-Being</div>        
            </div> 
            <div style={{fontFamily:customTitleFontFam,marginBottom:20,marginTop:'20px',fontSize:'16px',fontWeight:'500'}}>Search All Terms:</div>
					<Grid stackable>

					<Grid.Row>
              <Grid.Column style={{ flex: 1, paddingTop:0 }}>
					<div className='header-text'>
		              	<Input
		                ref={this.handleRef}
		                placeholder='Search in English or Yugtun...'
		                // action={{ icon: (this.state.search > 0 ? 'x': null), transparent:true,size:'huge', onClick: () => {this.setState({search:''})}}}
		                icon={this.state.search.length > 0 ? <Icon name='x' color='grey' onClick={()=>{this.setState({search:''})}} link /> : null}
		                // iconPosition='right'
		                size='huge'
		                onChange={this.onChangeSearch.bind(this,false,0)}
                    spellcheck="false"
		                value={this.state.search}
		                // onKeyPress={this.onKeyPress}
		                fluid>

		                </Input> 
					</div>
					</Grid.Column>
				</Grid.Row>




				</Grid>
          {displayList ?
            <div style={{padding:14,marginTop:'20px'}}>
              <Grid style={{backgroundColor:'#8c75a0',color:'white',fontWeight:'600',fontSize:'16px'}}>
              <Grid.Row columns={2}>
              <Grid.Column>
                <div>
                  <span>{"English"}</span>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div>
                  <span>{"Yugtun"}</span>
                </div>
              </Grid.Column>
              </Grid.Row>
              </Grid>

              {displayList && this.state.homeMode === 0 ?
              	wordsList.map((word, index) => 
						    {
                  let strongestHit = -100000000;
                  let bestHitIndex = -1;
                  let bestHitStartIndex = -1
                  Array.from(Array(4).keys()).reverse().map((i)=>{
                    if (word[i] !== null && word[i].score > strongestHit) {
                      strongestHit = word[i].score
                      bestHitIndex = i
                      bestHitStartIndex = Math.floor(i/2)
                    }
                  })

                return <Grid style={{fontSize:'16px',backgroundColor:(index%2 == 1 ? '#F9F9F9' : 'white')}} key={word.obj.id}>
                  <Grid.Row style={{fontWeight:500}} columns={2}>
                    <Grid.Column>
				          		<div> 
                        {word[0] != null && bestHitIndex == 0 ?
                          <span dangerouslySetInnerHTML={{__html:fuzzysort.highlight(word[0],"<i>", '</i>')}}></span>
                          :
                          <span>{word.obj.eTerm}</span>
                        }
                        {'m'+word.obj.id+'_e1' in this.props.audioFiles ?
                          <Icon onClick={()=>this.repeatAudio('m'+word.obj.id+'_e1')} circular style={{marginLeft:'10px',fontSize:(window.innerWidth < 480 ? '12px' : '14px'),color:'#969696',cursor:'pointer'}} name='volume up' />
                          :
                          null
                        }
                      </div>
                    </Grid.Column>
                    <Grid.Column>
                      <div>
                        {word[1] != null && bestHitIndex == 1 ?
                          <span dangerouslySetInnerHTML={{__html:fuzzysort.highlight(word[1],"<i>", '</i>')}}></span>
                          :
                          <span>{word.obj.yTerm}</span>
                        }
                        {'m'+word.obj.id+'_y1' in this.props.audioFiles ?
                          <Icon onClick={()=>this.repeatAudio('m'+word.obj.id+'_y1')} circular style={{marginLeft:'10px',fontSize:(window.innerWidth < 480 ? '12px' : '14px'),color:'#969696',cursor:'pointer'}} name='volume up' />
                          :
                          null
                        }
				              </div>
                    </Grid.Column>
						      </Grid.Row>
						      <Grid.Row style={{paddingTop:'6px',paddingBottom:'16px',fontSize:'15px'}}columns={2}>
                    <Grid.Column>
                    <div>
                    {word[2] != null && bestHitIndex == 2 ?
                      <span dangerouslySetInnerHTML={{__html:fuzzysort.highlight(word[2], '<i>', '</i>')}}></span>
                      :
                      (word.obj.eDesc.length > previewCharLimit && dopreview?
                        <span>{word.obj.eDesc.substring(0,previewCharLimit)}<span style={{color:'grey'}}>{'...'}</span></span>
                        :
                        <span>{word.obj.eDesc}</span>
                      )                        
                    }
                    </div>
                    </Grid.Column>
                    <Grid.Column>
                    <div>
                    {word[3] != null && bestHitIndex == 3 ?
                      <span dangerouslySetInnerHTML={{__html: fuzzysort.highlight(word[3], '<i>', '</i>')}}></span>
                      :
                      (word.obj.yDesc.length > previewCharLimit && dopreview ?
                        <span>{word.obj.yDesc.substring(0,previewCharLimit)}<span style={{color:'grey'}}>{'...'}</span></span>
                        :
                        <span>{word.obj.yDesc}</span>
                      )       
                    }
                    </div>                    
                    </Grid.Column>
                  </Grid.Row>

                  {index in this.state.activeAudioIndex ?
                    <Grid.Row columns={2}>
                      <Grid.Column>
                        {'m'+word.obj.id+'_e2' in this.props.audioFiles ?
                          <div>
                            <audio controls style={{width:'-webkit-fill-available',height:40}} src={API_URL + "/aijaudiolibrary/"+'m'+word.obj.id+'_e2'} />
                          </div>
                          :
                          null
                        }   
                      </Grid.Column>
                      <Grid.Column>
                        {'m'+word.obj.id+'_y2' in this.props.audioFiles ?
                          <div>
                            <audio controls style={{width:'-webkit-fill-available',height:40}} src={API_URL + "/aijaudiolibrary/"+'m'+word.obj.id+'_y2'} />
                          </div>
                          :
                          null
                        }  
                      </Grid.Column>
                    </Grid.Row>
                    :
                    null
                  }

                  {index in this.state.activeAudioIndex ?
                    <Grid.Row>
                    <Grid.Column>
                    <div style={{display:'flex',lineHeight:'21px',fontSize:'15px'}}>
                      <div style={{flex:1}} />
                      <div style={{flex:3,paddingRight:'6px'}}>
{/*                        <div>
                        <span style={{fontWeight:'500'}}>{'Translator: '}</span>
                        </div>
                        <div>
                        <span style={{fontWeight:'500'}}>{'Speaker: '}</span>
                        </div>*/}
                        <div>
                        <span style={{fontWeight:'500'}}>{'Resource: '}</span>
                        </div>                    
                      </div>
                      <div style={{flex:13}}>
{/*                        <div>
                        <span>{'Veronica Kaganak'}</span>
                        </div>
                        <div>
                        <span>{'Veronica Kaganak'}</span>
                        </div>*/}
                        <div>
                        <a target="_blank" href={'https://akijp.yugtun.com/appendix/' + word.obj.resourceID}>
                          <span style={{cursor:'pointer',color:'#4a80b5'}}>{this.props.resourceIDs[word.obj.resourceID][0][0]+' - '+this.props.resourceIDs[word.obj.resourceID][1][0]}</span>
                        </a>
                        </div>
                      </div>
                      <div style={{flex:1}} />
                    </div>
                    </Grid.Column>
                    </Grid.Row>
                    :
                    null
                  }


                  {'m'+word.obj.id+'_e2' in this.props.audioFiles  || 'm'+word.obj.id+'_y2' in this.props.audioFiles ?
                    <Grid.Row style={{paddingTop:0,fontSize:'14px',justifyContent:'flex-end'}}>
                    <Button style={{marginRight:'14px'}} onClick={()=>this.setActiveAudioIndex(word,index)} basic>
                    <div style={{color:'#A2A2A2'}}>
                    {'More Audio'}
                    {index in this.state.activeAudioIndex ?
                      <Icon style={{paddingLeft:'5px'}} name='chevron up' />
                      :
                      <Icon style={{paddingLeft:'5px'}} name='chevron down' />
                    }                    
                    </div>
                    </Button>
                    </Grid.Row>
                    :
                    <Grid.Row style={{padding:9}} />
                  }

                </Grid>
						    })
						    :
						    null
              	}
          </div>
          :
          null
        }

        <List>
      	<div>

          {emptyList ? <div style={{padding:20,textAlign:'center',fontSize:'16px',fontStyle:'italic'}}>No matches...</div>: ''}


          {!displayList && this.state.homeMode === 0 && !emptyList ? 
            <div style={{display:'flex',justifyContent:'center',padding:'30px 0px',marginBottom:'10px'}}>
              <div style={{fontSize:'1.2rem',color:'#555555',lineHeight:1.6,maxWidth:550}}>
                <div>
                <div style={{marginBottom:10}}> Type any English or Yugtun word and matching behavioral health terms will show automatically.</div>
                <div> Examples: </div>
                <div>
                <span onClick={()=>{this.setState({search:"Stigma",wordsList: fuzzysort.go("Stigma", this.props.masterMedicalList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>Stigma</span>
                <span>{', '}</span>
                <span onClick={()=>{this.setState({search:"Umyuarniurun",wordsList: fuzzysort.go('Umyuarniurun', this.props.masterMedicalList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>Umyuarniurun</span>
                <span>{', '}</span>
                <span onClick={()=>{this.setState({search:'Self-Esteem',wordsList: fuzzysort.go('Self-Esteem', this.props.masterMedicalList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>Self-Esteem</span>         
                <span>{', '}</span>
                <span onClick={()=>{this.setState({search:'Angniitelleq',wordsList: fuzzysort.go('Angniitelleq', this.props.masterMedicalList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>Angniitelleq</span>
                <span>{', '}</span>                
                <span onClick={()=>{this.setState({search:'Anxiety',wordsList: fuzzysort.go('Anxiety', this.props.masterMedicalList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>Anxiety</span>
                <span>{', '}</span>
                <span onClick={()=>{this.setState({search:"Piciunritniyaraq",wordsList: fuzzysort.go('Piciunritniyaraq', this.props.masterMedicalList, options1)})}} style={{color:'#4A80B5',cursor:'pointer'}}>Piciunritniyaraq</span>
                </div>
                </div>

          <div style={{paddingTop:'15px'}}> Explore the appendices: </div>
          <List bulleted>
          <List.Item>
          <Link to={{pathname: '/appendix/5', state: {}}}>
              <span style={{textDecoration:'underline',color:'#4A80B5',cursor:'pointer'}}>{'Terms Related to Coping and Recovery'}</span>
          </Link>
          </List.Item>
          <List.Item>
          <Link to={{pathname: '/appendix/10', state: {}}}>
              <span style={{textDecoration:'underline',color:'#4A80B5',cursor:'pointer'}}>{'Finding the Right Provider'}</span>
          </Link>
          </List.Item>
          <List.Item>
          <span>{'And more: '}</span>
          <Link to={{pathname: '/appendix', state: {}}}>
              <span style={{textDecoration:'underline',color:'#4A80B5',cursor:'pointer'}}>{'See all appendices'}</span>
          </Link>
          </List.Item>
          </List>

              </div>
            </div>
            :
            null
          }



        <Grid style={{fontSize:'15px'}}>
        <Grid.Row style={{marginTop:0,marginBottom:14}}>
        <Grid.Column>
        <Citation />
        </Grid.Column>
        </Grid.Row>
        </Grid>

        </div>

            </List>






        </Grid.Column>
        </Grid.Row>
      </Grid>


			</div>
		);
	}
}
export default NewHome;